<cap-list-loader [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>
<ng-template #tableHeaders>
  <tr>
    <th class="noselect">{{ "Gemeinde" | translate }}</th>
    <th class="noselect">{{ "Nummer" | translate }}</th>
    <th class="noselect">{{ "Art" | translate }}</th>
    <th class="noselect">E-GRID</th>
  </tr>
</ng-template>
<ng-template #tableRows>
  @for (grundstueck of listLoader?.items; track grundstueck) {
    <tr>
      <td>
        <cap-link
          [queryParams]="getQueryParams(grundstueck)"
          [target]="navTargets.NAV_GRUNDSTUECK"
          [tooltipOverride]="'DetailsZuGrundstueckAusSichtGrundbuch'">
          {{ grundstueck.grundstueckNummer.gemeinde.name }}
        </cap-link>
      </td>
      <td>
        <cap-link
          [queryParams]="getQueryParams(grundstueck)"
          [target]="navTargets.NAV_GRUNDSTUECK"
          [tooltipOverride]="'DetailsZuGrundstueckAusSichtGrundbuch'">
          {{ grundstueck.grundstueckNummer.nummer }}
          @if (grundstueck.grundstueckNummer.nummerZusatz) {
            <span>-{{ grundstueck.grundstueckNummer.nummerZusatz }}</span>
          }
        </cap-link>
      </td>
      <td>
        <cap-link
          [queryParams]="getQueryParams(grundstueck)"
          [target]="navTargets.NAV_GRUNDSTUECK"
          [tooltipOverride]="'DetailsZuGrundstueckAusSichtGrundbuch'">
          {{ grundstueck.grundstueckArt | translate }}
        </cap-link>
      </td>
      <td>
        <cap-link
          [queryParams]="getQueryParams(grundstueck)"
          [target]="navTargets.NAV_GRUNDSTUECK"
          [tooltipOverride]="'DetailsZuGrundstueckAusSichtGrundbuch'">
          {{ grundstueck.egrid?.value }}
        </cap-link>
      </td>
    </tr>
  }
</ng-template>

<ng-template #keine>
  <div class="mb-2">
    <span>{{"Keine" | translate}}</span>
  </div>
</ng-template>
